export const endpoints = {
  customer: {
    list: "/customers/list",
  },
  user: {
    list: "/users/list",
  },

  deliveryFee: {
    list: "/delivery-fees/list",
    get: (id: string) => `/delivery-fees/${id}`,
    create: "/delivery-fees",
    update: (id: string) => `/delivery-fees/${id}`,
    delete: (id: string) => `/delivery-fees/${id}`,
  },

  fulfillment: {
    list: "/fulfillments/list",
    get: (id: string) => `/fulfillments/${id}`,
    create: "/fulfillments",
    update: (id: string) => `/fulfillments/${id}`,
    delete: (id: string) => `/fulfillments/${id}`,
    updateCost: (id: string) => `/fulfillments/${id}/fee`,
    createGoodRequest: (id: string) => `/fulfillments/${id}/create-good-request`,
  },

  messageTemplate: {
    list: "/message-templates/list",
    get: (id: string) => `/message-templates/${id}`,
    create: "/message-templates",
    update: (id: string) => `/message-templates/${id}`,
    delete: (id: string) => `/message-templates/${id}`,
  },

  order: {
    list: "/orders/list",
    receipt: (id: string) => `/orders/${id}/receipt`,
  },

  variant: {
    list: "/product-variants/list",
  },

  stock: {
    recomputeAllStock: "/daily-stocks/recompute-all-stocks",
    bulkReceive: "/daily-stocks/bulk-receive",
    receive: "/daily-stocks/receive",
    adjustIn: "/daily-stocks/adjust-in",
    adjustOut: "/daily-stocks/adjust-out",
    csvReceive: "/daily-stocks/bulk-receive-csv",
  },

  product: {
    list: "/products/list",
    get: (id: string) => `/products/${id}`,
    create: "/products",
    update: (id: string) => `/products/${id}`,
    delete: (id: string) => `/products/${id}`,
  },

  pickup: {
    list: "/pickups/list",
    get: (id: string) => `/pickups/${id}`,
    create: "/pickups",
    update: (id: string) => `/pickups/${id}`,
    delete: (id: string) => `/pickups/${id}`,
  },

  inventoryLedger: {
    list: "/inventory-ledgers/list",
  },
};
